export default {
  tab: {
    dashboard: '定时任务总览',
    detail: '定时任务详情',
    index: '定时任务管理'
  },
  label: {
    jobSync: '职位拉取',
    applicationSync: '申请回传',
    applicationPullSync: '申请拉取',
    employeePullSync: '员工拉取',
    applicationStatusPullSync: '申请状态拉取',
    applicationStatusPushSync: '申请状态回传',
    otherSync: '其他',
    company: '公司名称',
    nextRunTime: '下次运行时间',
    integrationType: '集成类型',
    lastSyncStatus: '上次执行状态',
    viewDetail: '查看',
    option: '操作',
    onOff: 'On/Off',
    startTime: '开始时间',
    endTime: '结束时间',
    executeStatus: '执行状态',
    duration: '耗时',
    exception: '错误摘要',
    openJobCount: '职位更新数量',
    newJobCount: '职位新增数量',
    closeJobCount: '职位关闭数量',
    successApplicationCount: '回传成功数量',
    failApplicationCount: '回传失败数量',
    pendingApplicationCount: '回传执行中数量',
    successCount: '成功数量',
    failCount: '失败数量',
    scheduledTaskExecutorStatus: '定时任务执行器状态',
    executeHistory: '执行历史',
    systemName: '系统名称',
    job: {
      new: '新增职位',
      open: '已更新职位',
      close: '已关闭职位'
    },
    application: {
      success: '已回传申请',
      filed: '回传失败申请'
    },
    task: {
      total: '任务总数',
      open: '运行中',
      close: '关闭中',
      exception: '异常终止',
      current: '执行中'
    },
    dayRange: {
      0: '今天',
      7: '7 天',
      15: '15 天',
      30: '30 天'
    },
    errorRecordList: '错误记录列表',
    jobId: '职位ID-第三方职位ID',
    jobName: '职位名称',
    candidateId: '候选人ID',
    candidateEmail: '候选人邮箱',
    candidateName: '候选人姓名',
    errorDate: '报错时间',
    processStatus: '处理状态',
    startDate: '开始日期',
    endDate: '结束日期'
  },
  btn: {
    start: '启动',
    pause: '暂停',
    resume: '恢复',
    viewDetail: '查看详情',
    export: '导出',
    viewErrorDetail: '查看错误详情',
    markErrorHasProcessed: '标记为已处理'
  },
  executeStatus: {
    Executed: '执行成功',
    'Started execution': '执行中',
    'Error!': '异常终止'
  },
  resumeStatus: {
    yes: '是',
    no: '否'
  },
  recordStatus: {
    update: '更新',
    add: '新增',
    delete: '关闭',
    success: '成功',
    failed: '失败',
    pending: '执行中'
  },
  dialog: {
    jobId: '职位ID',
    jobName: '职位名称',
    companyName: '公司名称',
    atsJobId: '第三方职位ID',
    createTime: '创建时间',
    updateTime: '更新时间',
    option: '操作',
    candidateId: '求职者ID',
    candidateEmail: '求职者邮箱',
    candidateName: '求职者姓名',
    candidateStatus: '当前状态',
    applyTime: '申请时间',
    isFinish: '是否完成',
    syncStatus: '同步状态',
    atsEmployeeId: '第三方员工ID',
    employeeId: '员工ID',
    employeeName: '员工姓名',
    employeeEmail: '员工邮箱',
    fromCandidateStatus: '原状态',
    toCandidateStatus: '新状态',
    retry: '重试',
    syncErrorType: '错误类型',
    syncErrorDetail: '错误详情'
  },
  placeholder: {
    keyword: '请输入关键词',
    selectCompany: '请选择公司',
    selectType: '请选择集成类型',
    selectStatus: 'On/Off',
    selectProcessStatus: '请选择处理状态'
  },
  message: {
    startConfirm: '您确认启动任务？',
    pauseConfirm: '您确认暂停任务？',
    resumeConfirm: '您确认恢复任务？',
    removeConfirm: '您确认移除任务？',
    addConfirm: '您确认添加任务？',
    retryTip: '点击添加至下次回传列表',
    retrySuccess: '重试成功！',
    noErrorInfo: '未记录到错误信息！'
  },
  tips: {
    operateSuccess: '操作成功，任务预计在一分钟内执行，请稍后刷新页面查看状态！'
  },
  ERROR_TYPE: {
    UNKNOWN_ERROR: '未知错误',
    TASK_FINISHED_ERROR: '任务异常结束',
    USER_INVALID_ERROR: '用户信息错误',
    REQUEST_FAILED_ERROR: '请求发送失败',
    REQUEST_TIMEOUT_ERROR: '请求发送超时',
    JOB_NOT_FOUND_ERROR: '未找到职位',
    APPLICATION_SYNC_PHONE_VALIDATION_ERROR: '申请回传 - 手机号验证错误',
    APPLICATION_SYNC_CITY_VALIDATION_ERROR: '申请回传 - 城市验证错误',
    APPLICATION_SYNC_SOURCE_VALIDATION_ERROR: '申请回传 - Source验证失败',
    APPLICATION_SYNC_EMPLOYEE_ID_VALIDATION_ERROR: '申请回传 - 员工ID验证失败',
    APPLICATION_SYNC_POSTAL_CODE_VALIDATION_ERROR: '申请回传 - 邮编验证错误',
    APPLICATION_SYNC_EMAIL_EMPTY_ERROR: '申请回传 - 邮箱为空',
    APPLICATION_SYNC_NOT_ALLOW_RECOMMEND_ERROR: '申请回传 - 不允许推荐',
    APPLICATION_STATUS_PULL_NOT_FOUND_ERROR: '申请状态拉取 - 未找到申请',
    APPLICATION_STATUS_PULL_NOT_FOUND_STATUS_ERROR: '申请状态拉取 - 未找到状态',
    APPLICATION_STATUS_PUSH_NOT_FOUND_STATUS_ERROR: '申请状态回传 - 未找到状态',
    APPLICATION_STATUS_PUSH_WORKFLOW_ERROR: '申请状态回传 - 状态流程错误',
    MSD_DISPOSITION_STAGE_NOT_FOUND_ERROR: 'MSD 申请状态拉取 - 未找到 MSD 状态 Stage',
    MSD_APPLICATION_STATUS_NOT_FOUND_ERROR: 'MSD 申请状态拉取 - 未找到 MSD 状态',
    APPLICATION_STATUS_NO_UPDATE_ERROR: '申请状态无更新',
    APPLICATION_HAS_EXIST_ERROR: '申请已存在',
    CANDIDATE_CREATE_FAILED_ERROR: '申请回传 - Candidate 创建失败',
    CANDIDATE_ID_MISSING_ERROR: '申请回传 - 无法获取 Candidate ID',
    CANDIDATE_SYNC_TIMEOUT_ERROR: '申请回传 - Candidate 同步超时',
    CANDIDATE_NETWORK_ERROR: '申请回传 - Candidate 同步网络错误'
  },
  PROCESS_STATUS: {
    UNPROCESSED: '未处理',
    PROCESSED: '已处理'
  }
}
